import BuildIcon from '@mui/icons-material/Build';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ForumIcon from '@mui/icons-material/Forum';
import GroupIcon from '@mui/icons-material/Group';
import type { SectionNavGroup } from '../components/SectionNav';

/**
 * Per-car dashboard section registry. Adding a new section = one entry here.
 * Keys double as the URL `?tab=` value and are translated via `labelKey`.
 *
 * Keep groups deliberate: they become sidebar subheaders and frame the user's
 * mental model of "what I publish" vs "what others do" vs (later) "insights".
 */

export type GarageSectionKey = 'goals' | 'activities' | 'threads' | 'messages' | 'contributors';

// Goals come first and open by default — it's the screen owners use most.
const SECTION_KEYS: GarageSectionKey[] = ['goals', 'activities', 'threads', 'messages', 'contributors'];

export function isValidGarageSection(value: string | null): value is GarageSectionKey {
  return value !== null && (SECTION_KEYS as string[]).includes(value);
}

export const GARAGE_SECTION_GROUPS: SectionNavGroup[] = [
  {
    key: 'content',
    labelKey: 'garageCar.groups.content',
    items: [
      {
        key: 'goals',
        labelKey: 'garageCar.tabs.goals',
        icon: <SportsScoreIcon fontSize="small" />,
      },
      {
        key: 'activities',
        labelKey: 'garageCar.tabs.activities',
        icon: <BuildIcon fontSize="small" />,
      },
      {
        key: 'threads',
        labelKey: 'garageCar.tabs.threads',
        icon: <ForumIcon fontSize="small" />,
      },
    ],
  },
  {
    key: 'community',
    labelKey: 'garageCar.groups.community',
    items: [
      {
        key: 'messages',
        labelKey: 'garageCar.tabs.messages',
        icon: <ChatBubbleOutlineIcon fontSize="small" />,
      },
      {
        key: 'contributors',
        labelKey: 'garageCar.tabs.contributors',
        icon: <GroupIcon fontSize="small" />,
      },
    ],
  },
];
